import i18n from "@/i18n";

// VLink图片排序配置
export const imgSequenceOptions = () => [
    {
        label: i18n.t("zhiji.materialLibrary.byTime"),
        value: "updateTime"
    }
];

// VLink资源库使用状态配置
export const usageStatusOptions = () => [
    {
        label: i18n.t("zhiji.materialLibrary.allContent"),
        value: ""
    },
    {
        label: i18n.t("zhiji.materialLibrary.notUsed"),
        value: "0"
    },
    {
        label: i18n.t("zhiji.materialLibrary.inUse"),
        value: "1"
    }
];

// VLink图片编辑弹框配置
export const pictureEditConfig = () => ({
    pictureName: i18n.t("zhiji.materialLibrary.picName"),
    namePlaceholder: i18n.t("zhiji.materialLibrary.picEnterTip"),
    pictureTag: i18n.t("zhiji.materialLibrary.picClassify"),
    tagPlaceholder: i18n.t("zhiji.materialLibrary.chosePicLabel"),
    bigPic: i18n.t("zhiji.materialLibrary.bigPic"),
    smallPic: i18n.t("zhiji.materialLibrary.smallPic"),
    noCoverIcon: {
        position: "-56px 0",
        label: i18n.t("zhiji.materialLibrary.uploadCover")
    },
    operateIcons: [
        {
            type: "update",
            position: "-38px -77px",
            name: i18n.t("zhiji.materialLibrary.replacePic")
        }
    ],
    viewIcon: {
        position: "-172px -74px",
        isShowIcon: true
    }
});

// VLink视频，攻略排序配置
export const sequenceOptions = () => [
    {
        label: i18n.t("zhiji.materialLibrary.byTime"),
        value: "updateTime"
    },
    {
        label: i18n.t("zhiji.materialLibrary.byRead"),
        value: "readVolume"
    }
];

// VLink视频、攻略来源配置
export const sourceOptions = () => [
    {
        label: i18n.t("zhiji.materialLibrary.allSources"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.materialLibrary.selfBuilt"),
        value: "self"
    }
];

// VLink视频编辑弹框配置
export const videoEditConfig = () => ({
    videoPlatform: i18n.t("zhiji.materialLibrary.videoPlatform"),
    videoName: i18n.t("zhiji.materialLibrary.videoName"),
    namePlaceholder: i18n.t("zhiji.materialLibrary.enterVideoName"),
    videoTag: i18n.t("zhiji.materialLibrary.videoTag"),
    videoLang: i18n.t("zhiji.common.language"),
    tagPlaceholder: i18n.t("zhiji.materialLibrary.chosePicLabel"),
    videoCover: i18n.t("zhiji.materialLibrary.videoCover"),
    videoUrl: i18n.t("zhiji.materialLibrary.videoLink"),
    urlPlaceholder: i18n.t("zhiji.materialLibrary.enterVideoUrl"),
    duration: i18n.t("zhiji.materialLibrary.duration"),
    durationLabel: i18n.t("zhiji.materialLibrary.durationLabel"),
    videoSize: i18n.t("zhiji.materialLibrary.videoSize"),
    sizeLabel: i18n.t("zhiji.materialLibrary.sizeLabel"),
    videoId: i18n.t("zhiji.materialLibrary.videoId"),
    videoIdLabel: i18n.t("zhiji.materialLibrary.videoIdLabel"),
    videoLabel: i18n.t("zhiji.materialLibrary.label"),
    playNumber: i18n.t("zhiji.materialLibrary.playNumber"),
    likeNumber: i18n.t("zhiji.materialLibrary.likeNumber"),
    showDate: i18n.t("zhiji.materialLibrary.showDate"),
    labelHolder: i18n.t("zhiji.materialLibrary.labelHolder"),
    playNumberHolder: i18n.t("zhiji.materialLibrary.playNumberHolder"),
    likeNumberHolder: i18n.t("zhiji.materialLibrary.likeNumberHolder"),
    showDateHolder: i18n.t("zhiji.materialLibrary.showDateHolder"),
    noCoverIcon: {
        position: "-56px 0",
        label: i18n.t("zhiji.materialLibrary.uploadCover")
    },
    operateIcons: [
        {
            type: "update",
            position: "-38px -77px",
            name: i18n.t("zhiji.materialLibrary.replacePic")
        }
    ],
    viewIcon: {
        position: "-172px -74px",
        isShowIcon: true
    }
});

// vlink攻略弹框配置
export const editModalConfig = () => ({
    checkFormat: "协议选择",
    strategyContent: i18n.t("zhiji.materialLibrary.strategyContent"),
    strategyPlatform: i18n.t("zhiji.materialLibrary.guidesPlatform"),
    strategyName: i18n.t("zhiji.materialLibrary.guidesTitle"),
    namePlaceholder: i18n.t("zhiji.materialLibrary.enterGuidesTitle"),
    strategyTag: i18n.t("zhiji.materialLibrary.guidesCategory"),
    guideLang: i18n.t("zhiji.common.language"),
    tagPlaceholder: i18n.t("zhiji.materialLibrary.clickCategory"),
    strategyCover: i18n.t("zhiji.materialLibrary.guidesCover"),
    strategyLabel: i18n.t("zhiji.materialLibrary.label"),
    playNumber: i18n.t("zhiji.materialLibrary.playNumber"),
    likeNumber: i18n.t("zhiji.materialLibrary.likeNumber"),
    showDate: i18n.t("zhiji.materialLibrary.showDate"),
    labelHolder: i18n.t("zhiji.materialLibrary.labelHolder"),
    playNumberHolder: i18n.t("zhiji.materialLibrary.playNumberHolder"),
    likeNumberHolder: i18n.t("zhiji.materialLibrary.likeNumberHolder"),
    showDateHolder: i18n.t("zhiji.materialLibrary.showDateHolder"),
    noCoverIcon: {
        position: "-56px 0",
        label: i18n.t("zhiji.materialLibrary.uploadCover")
    },
    operateIcons: [
        {
            type: "update",
            position: "-38px -77px",
            name: i18n.t("zhiji.materialLibrary.replacePic")
        }
    ],
    viewIcon: {
        position: "-172px -74px",
        isShowIcon: true
    }
});

// 新增视频时渠道区分
export const videoChannel = {
    default: 0 // 小悦
};

// pageLengthRank 选择
export const pageLengthRank = [15, 30, 50];
